'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _SvgIcon = require('./SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _SvgIcon2.default;


/*****************
 ** WEBPACK FOOTER
 ** ./~/material-ui/SvgIcon/index.js
 ** module id = 3
 ** module chunks = 0
 **/